import { initialViewerState } from "./initialState";
import type { ResetActions, ViewerSliceCreator } from "./types";

export const createResetSlice: ViewerSliceCreator<ResetActions> = (set) => ({
  reset: () =>
    set((state) => {
      Object.assign(state, initialViewerState);
      state.guiContainerChildren = { root: new Set() };
    }),
});
